import React from 'react';
import update from 'immutability-helper';
import Input from './Input'; 
import ReactResponsiveSelect from 'react-responsive-select';

const caretIcon = (
    <svg className="caret-icon" x="0px" y="0px" width="11.848px" height="6.338px"
         viewBox="351.584 2118.292 11.848 6.338">
        <g>
            <path
                d="M363.311,2118.414c-0.164-0.163-0.429-0.163-0.592,0l-5.205,5.216l-5.215-5.216c-0.163-0.163-0.429-0.163-0.592,0s-0.163,0.429,0,0.592l5.501,5.501c0.082,0.082,0.184,0.123,0.296,0.123c0.103,0,0.215-0.041,0.296-0.123l5.501-5.501C363.474,2118.843,363.474,2118.577,363.311,2118.414L363.311,2118.414z"/>
        </g>
    </svg>
);

export default class Quantity extends React.Component {

    constructor(props) {
        super(props);
        if(props.quantityranges.length){
            this.state = {
                quantityranges: props.quantityranges
            };
        } else {
            this.state = {
                quantityranges: [{start_range: '', end_range: '', dis_type: '', dis_value: ''}]
            };
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.quantityranges !== this.props.quantityranges){
            this.setState({quantityranges:nextProps.quantityranges});
        }
    }

    handleRemove(event, i) {
        this.setState(() => ({
            quantityranges: update(this.state.quantityranges, { $splice: [[i, 1]] } )
        }), () => {
            this.props.onChange(this.state.quantityranges)
        })
    }

    handleAdd(event, i) {
        let item = { start_range: '', end_range: '', dis_type: '', dis_value: '' };
        this.setState(() => ({
            quantityranges: update(this.state.quantityranges, { $push: [item] })
        }), () => {
            this.props.onChange(this.state.quantityranges)
        });
    }

    handleRangeInput(e, i) {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(() => ({
            quantityranges: update(this.state.quantityranges, { [i]: { [name] : {$set: value} }  })
        }), () => {
            this.props.onChange(this.state.quantityranges)
        })
    }

    handleRangeSelect(e, i) {
        let value = e.value;
        let name = e.name;
        this.setState(() => ({
            quantityranges: update(this.state.quantityranges, { [i]: { [name] : {$set: value} }  })
        }), () => {
            this.props.onChange(this.state.quantityranges)
        })
    }

    render() {
        let render;
        if (this.state.quantityranges.length) {
            render = this.state.quantityranges.map((e, i) => {
                let value_render = '';
                value_render = (
                    <div className="awdp_repeat range_picker clearfix">
                        <div className="awdp_half">
                            <Input inputType={'number'}
                                name={'start_range'}
                                value={e.start_range}
                                min={'1'}
                                title={ ( i == 0 ) ? 'Minimum Quantity' : '' }
                                placeholder={'Minimum Quantity'}
                                handleChange={(e) => {
                                    this.handleRangeInput(e, i)
                                }} />
                            <Input inputType={'number'}
                                name={'end_range'}
                                value={e.end_range}
                                min={'1'}
                                title={ ( i == 0 ) ? 'Maximum Quantity' : '' } 
                                placeholder={'Maximum Quantity'}
                                handleChange={(e) => {
                                    this.handleRangeInput(e, i)
                                }} />
                        </div>
                        <div className="awdp_half">
                            <div class="range_dis_type">
                                { ( i == 0 ) ? <label className="form-label">Discount Type</label> : '' }
                                <ReactResponsiveSelect
                                    name={'dis_type'}
                                    options={[
                                        {text: 'Percentage', value: 'percentage'},
                                        {text: 'Fixed price', value: 'fixed'}
                                    ]} 
                                    caretIcon={caretIcon}
                                    noSelectionLabel={'Select one'}
                                    onChange={(e) => {
                                        this.handleRangeSelect(e, i)
                                    }}
                                    selectedValue={e.dis_type} />
                            </div>
                            <Input inputType={'number'}
                                title={ ( i == 0 ) ? 'Value' : ''}
                                name={'dis_value'}
                                value={e.dis_value}
                                min={'0'}
                                placeholder={'Value'}
                                handleChange={(e) => {
                                    this.handleRangeInput(e, i)
                                }} />
                        </div>
                    </div>
                );
                return (
                    <div className="awdp_group quantity_group clearfix">
                        {value_render}
                       
                        { i != 0 ?
                            <button className="awdp_add awdp_remove quantity_remove" title="Remove" onClick={(event) => {
                                this.handleRemove(event, i);
                            }}></button>
                        : '' }

                        { i == (this.state.quantityranges.length - 1) ?
                            <button className="awdp_add quantity_add" title="Add" onClick={(event) => {
                                this.handleAdd(event, i);
                            }}></button>
                        : '' }

                    </div>
                );
            });
        }

        return (
            <div>
                {render}
            </div>
        );
    }
}